module.exports = __webpack_public_path__ + "static/media/Mail.7b13b024.svg";